export default "__VITE_ASSET__Ck7hY8by__"